module.exports = __webpack_public_path__ + "static/media/024.69e16af6.jpg";